import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Normal web sayfası gibi davranması için basit çözüm
 * Her route değişiminde window'u en üste zorla götür
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation()
  
  useEffect(() => {
    // Tamamen basit: sadece window'u resetle
    window.scrollTo(0, 0)
  }, [pathname])
}

export default useScrollToTop
